//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/singleNumberReportTemplate.html"], function (
  Marionette,
  SingleNumberReportTemplate,
) {
  "use strict";

  var SingleNumberReportView = {};

  SingleNumberReportView.view = Marionette.ItemView.extend({
    template: SingleNumberReportTemplate,
    className: "single-number-report",
    modelEvents: {
      change: "render",
    },
  });

  return SingleNumberReportView;
});
